import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Solution.module.css';

import { 
  school1, school2, school3, school4, school5, school6, school7, school8, school9, school10, school11, school12, school13, school14, school15,
  schoolSub1, schoolSub2, schoolSub3, schoolSub4, 
} from '../../assets/images/solution/solutionImages';
import TextImgCard from '../../components/Card/TextImgCard';
import { schoolServiceHeaderData, schoolServiceBodytData, schoolOtherHeaderData, schoolOtherBodytData } from './SolutionData';
import BasicTable from '../../components/Table/BasicTable';

const SchoolPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="solution" />
      <div className='sideBannerComp flex-coulum'>
          <div>
            <SideBannerComponents pageKey="solution" />
          </div>
  
          <div className='com-content-wrap mt-200'>
            <div style={{minHeight:'650px'}}>
            <div className={isMobile() ? 'mb-20' : 'mb-80'}>
              <img src={school1} alt='school' className={`${S.solContentImg} mt-30`}/>
            </div>
            <div className='mb-50'>
              <img src={school2} alt='school' className={S.solContentImg}/>
              <div id={S.scIntroText}>공공기관에서는 ‘<span className={S.redColor}>아이킵스</span>’를 선택했습니다.</div>
              <img src={school3} alt='school' className={S.solContentImg}/>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                원생관리
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                원생의 등록과 수정 등 기본정보를 관리할 수 있는 메뉴이며 원생 개인별 출결, 수강정보, 수납관리를 확인 및 관리할 수 있습니다.<br />
                개인별 알림장, 앨범 등 작성이 가능하며, 함께 제공되는 학부모 전용 APP을 통해 쉽고 빠르게 소통할 수 있는 기능입니다.
              </div>
              <div className='flex-row jt-con-between' >
              {/* <div className={S.scImgWrapDiv}> */}
                <img src={school4} alt='school' className='mt-50' id={S.scImg4}/>
                <div id={S.scImgWrapDiv}>
                  <img src={school5} alt='school' id={S.scImg5} className='mt-50 mr-10'/>
                  <img src={school6} alt='school' id={S.scImg6} className='mt-50'/>
                </div>
                
              </div>
            </div>
  
            <div className='mb-50 mt-10'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                출결관리
              </div>
              <div className={`${S.smallContentText} mt-30`}>
                원생에게 발급되는 출결용 NFC태그를 이용하여 등하원 시 출결 및 출결현황을 조회할 수 있습니다.<br />
                원생의 등하원시 실시간 스마트폰 APP 푸쉬를 통해 알림을 받아볼 수 있어, 안전한 등하원을 확인할 수 있습니다.<br />
                원생별, 반별 등 뿐만 아니라 일별, 월별 출결 현황을 한눈에 볼 수 있으며, Execel 다운로드 기능으로 제출용 보고서 기능도 가능합니다.<br />
                PC, 출결확인용 태블릿, 학부모에게 제공되는 APP을 통해 원생의 출결정보를 쉽게 확인 할 수 있습니다.
              </div>
              <div className={isMobile() ? 'flex-row jt-con-between mt-20' : 'flex-row mt-20'}>
                <TextImgCard 
                  imgPath={schoolSub1}
                  content={(<>거치형태 : 탁상형<br />출결장비 : 출결 태블릿 + 블루투스 NFC 리더기<br />출결태그 : SAFE</>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
                <TextImgCard 
                  imgPath={schoolSub2}
                  content={(<>거치형태 : 벽면형<br />출결장비 : 출결 태블릿 + USB NFC 리더기<br />출결태그 : 디자인 출결카드</>)}
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
              </div>
              <div className={isMobile() ? 'flex-row jt-con-between mt-20' : 'flex-row mt-20'}>
                <TextImgCard 
                  imgPath={schoolSub3}
                  title='관리자  PC Web 출결정보'
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
                <TextImgCard 
                  imgPath={schoolSub4}
                  title='태블릿, 스마트폰 APP 출결정보'
                  imgClass='tcImg'
                  wrapClass='tcListDiv'
                  titleClass='textCardBasicTitle'
                  contentClass='textCardBasicContent'
                />
              </div>
            </div>
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                수강관리
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                원생의 반과 수강과목을 설정하는 기능이며 그룹별, 반별 등 다양한 방법으로 원생 수강과목 관리가 가능합니다.<br />
                반, 수강과목별로 출결 현황 조회가 가능하며, 학년이 올라가거나, 심화과정수업으로 반, 수강과목 변경시 개인별, 그룹별<br />
                전반처리 기능으로 쉽게 일괄 변경이 가능합니다.
              </div>
              <div className={S.scContentDiv3}>
                <div><img src={school7} alt='school' id={S.scImg7} className='mt-70'/></div>
                <div><img src={school8} alt='school' id={S.scImg8} className='mt-70'/></div>
              </div>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                수납관리
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                수강료 수납과 같은 정기결제 및 교재비, 현장학습 등과 같은 일회성 결제관리를 효과적으로 관리 할 수 있으며<br />
                일회성, 월별 분기별, 년별 청구와 수납을 쉽게 설정하여 누락되지 않도록 관리 할 수 있습니다.<br />
                카드결제, 현금, 무통장입금 등 수납방법을 선택하여 수납관리 이력관리가 가능합니다.<br />
                관리자 페이지와 APP으로 원생의 수납 관리가 가능하며, 학부모전용 APP으로 자녀의 납부 이력을 한눈에 볼 수 있습니다.
              </div>
              <div className={S.scContentDiv4}>
                <img src={school9} alt='school' className='mt-50'  id={S.scImg9}/>
                <div id={S.scImgWrapDiv2}>
                  <img src={school10} alt='school' id={S.scImg10} className='mt-50 mr-10'/>
                  <img src={school11} alt='school' id={S.scImg11} className='mt-50'/>
                </div>
              </div>
            </div>
            
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                문자관리
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                등록된 원생, 학부모, 선생님에게 개인별 그룹별 등 쉽게 문자 발송이 가능합니다.<br />
                단문(SMS), 장문(LMS), 멀티(MMS) 유형별 메시지 발송이 가능하며, 실시간 메시지 발송 뿐만 아니라 지정 된 일자,<br />
                시간으로 예약발송이 가능합니다. 아이킵스는 업계 최저 문자발송 비용을 제공하며, 쉽고 빠르게 발송이 가능합니다.
              </div>
              <div className={S.scContentDiv5}>
                <div><img src={school12} alt='school' id={S.scImg12} className='mt-70 mr-40'/></div>
                <div><img src={school13} alt='school' id={S.scImg13} className='mt-70'/></div>
              </div>
            </div>
  
            <div className='mb-70'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                공지사항 / 알림장
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                통합 공지사항과 반별, 개인별 알림장을 작성할 수 있는 기능입니다.<br />
                중요 공지사항을 올리거나 반별 안내사항 및 개인별 안내사항을 개별적으로 등록이 가능하며 스마트폰 APP 푸쉬 알림을 통해<br />
                실시간으로 공지사항 및 알림 상담내용을 확인 할 수 있으며, 댓글을 통해 원과 학부모의 빠르고 쉬운 소통이 가능합니다.
              </div>
              <div className={S.scContentDiv4}>
                <div><img src={school14} alt='school' id={S.scImg14} className='mt-50'/></div>
                <div><img src={school15} alt='school' id={S.scImg15} className='mt-50 mr-10'/></div>
              </div>
            </div>
  
            <div className='mb-50'>
              <div className={S.textLineDiv}></div>
              <div className={S.titleText}>
                서비스 이용 요금
              </div>
              <div className={`${S.smallContentText} mt-20`}>
                저렴한 월비용응로 효과적인 원생 관리 및 출결 관리 NFC 또는 태블릿 키패드를 이용한 출결방식으로 원하시는<br />
                출결 인증 방식에 맞춰 초기 도입비용 부담을 줄여드립니다. (기존 사용중이신 태블릿으로 사용도 가능합니다.)
              </div>
              <div className='mt-50'>
                <div className={`${S.bSmallContentText} mb-20`}>서비스 요금</div>
                <BasicTable headers={schoolServiceHeaderData} items={schoolServiceBodytData} />
              </div>
              <div className='mt-50'>
                <div className={`${S.bSmallContentText} mb-20`}>기타 출결 인증용 장비</div>
                <BasicTable headers={schoolOtherHeaderData} items={schoolOtherBodytData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolPage;
